(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["svato-atouts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('svato-atouts')) {
    customElements.define(
      'svato-atouts',
      class extends HTMLElement {
        connectedCallback() {
          this.monterSlider();
          this.addEventListener('click', (e) => {
            const bouton = e.target.closest('.svato-atouts__bouton');
            if (!bouton) return;
            const ouvrir = bouton.getAttribute('aria-expanded') !== 'true';
            this.querySelectorAll('.svato-atouts__bouton[aria-expanded="true"]').forEach((b) => this.basculer(b, false));
            if (ouvrir) this.basculer(bouton, true);
          });
          this.addEventListener('keydown', (e) => {
            if (e.key !== 'Escape') return;
            const ouvert = this.querySelector('.svato-atouts__bouton[aria-expanded="true"]');
            if (ouvert) { this.basculer(ouvert, false); ouvert.focus(); }
          });
        }

        disconnectedCallback() {
          if (this.slider) this.slider.destroy(true);
        }

        /* Slider mobile avec Splide (même moteur que les autres carrousels du thème) :
           glisser au doigt et à la souris, points de pagination, pas de flèches. Détruit à partir de 750 px. */
        monterSlider(essai = 0) {
          if (!window.Splide) {
            if (essai < 100) setTimeout(() => this.monterSlider(essai + 1), 50);
            return;
          }
          const marge = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--page-margin-mobile')) || 20;
          this.slider = new window.Splide(this, {
            mediaQuery: 'min',
            fixedWidth: 240,
            gap: 12,
            padding: { left: marge, right: marge },
            arrows: false,
            pagination: this.querySelectorAll('.splide__slide').length > 1,
            drag: true,
            snap: true,
            trimSpace: 'move',
            omitEnd: true,
            flickMaxPages: 1,
            i18n: { slideX: 'Aller à l\'atout %s', pageX: 'Aller à l\'atout %s', carousel: 'carrousel' },
            breakpoints: { 750: { destroy: true } },
          });
          this.slider.mount();
        }

        basculer(bouton, ouvrir) {
          const panneau = document.getElementById(bouton.getAttribute('aria-controls'));
          bouton.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
          if (panneau) panneau.hidden = !ouvrir;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svato-composition"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initComposition(root) {
      if (root.dataset.svatoCompReady === 'true') return;
      root.dataset.svatoCompReady = 'true';

      var items = Array.prototype.slice.call(root.querySelectorAll('.svato-comp__item'));
      var hotspots = Array.prototype.slice.call(root.querySelectorAll('.svato-comp__hotspot'));
      var medias = Array.prototype.slice.call(root.querySelectorAll('.svato-comp__media'));
      var supportsExclusive = 'name' in document.createElement('details');

      function mediaFor(index) {
        var own = medias.filter(function (m) {
          return m.dataset.media === String(index);
        })[0];
        return own || medias[0];
      }

      function sync() {
        var openItem = items.filter(function (d) {
          return d.open;
        })[0];
        var index = openItem ? openItem.dataset.index : null;

        hotspots.forEach(function (h) {
          h.classList.toggle('is-active', h.dataset.target === index);
        });

        var target = index ? mediaFor(index) : medias[0];
        medias.forEach(function (m) {
          m.classList.toggle('is-visible', m === target);
        });
      }

      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          // Repli pour les navigateurs sans <details name> : fermeture manuelle des autres.
          if (item.open && !supportsExclusive) {
            items.forEach(function (other) {
              if (other !== item) other.open = false;
            });
          }
          sync();
        });
      });

      hotspots.forEach(function (hotspot) {
        hotspot.addEventListener('click', function () {
          var index = hotspot.dataset.target;
          items.forEach(function (item) {
            item.open = item.dataset.index === index;
          });
          sync();
          if (window.matchMedia('(max-width: 749px)').matches) {
            var openItem = items.filter(function (d) {
              return d.dataset.index === index;
            })[0];
            if (openItem) openItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });

      sync();
    }

    function initAll() {
      document.querySelectorAll('[data-svato-comp]').forEach(initComposition);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Éditeur de thème : la section est re-rendue à chaque modification.
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["svato-proportions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('svato-proportions')) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class SvatoProportions extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;
        this.visible = false;
        this.index = 0;

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (e) => {
            const n = this.tabs.length;
            let j = null;
            if (e.key === 'ArrowRight') j = (i + 1) % n;
            if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
            if (e.key === 'Home') j = 0;
            if (e.key === 'End') j = n - 1;
            if (j === null) return;
            e.preventDefault();
            this.select(j, true);
          });
        });

        // La vidéo ne joue que lorsque le bloc est à l'écran : pas de charge inutile plus haut dans la page.
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((en) => en.isIntersecting);
          this.sync();
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      select(i, focus) {
        if (i === this.index) return;
        this.index = i;
        this.tabs.forEach((t, k) => {
          const actif = k === i;
          t.setAttribute('aria-selected', actif ? 'true' : 'false');
          t.tabIndex = actif ? 0 : -1;
          if (actif && focus) t.focus();
        });
        this.panels.forEach((p, k) => { p.hidden = k !== i; });
        this.sync();
      }

      sync() {
        this.panels.forEach((p, k) => {
          const v = p.querySelector('video');
          if (!v) return;
          if (k === this.index && this.visible && this.autoplay) {
            if (v.preload === 'none') v.preload = 'auto';
            v.muted = true;
            v.play().catch(() => {});
          } else {
            v.pause();
          }
        });
      }
    }

    customElements.define('svato-proportions', SvatoProportions);
  })();

  } catch(e) { console.error(e); }
})();
})();
